<template>
  <div>
    <AllLogs></AllLogs>
  </div>
</template>

<script>
const AllLogs = defineAsyncComponent(() =>
  import("@/components/logs/CasesLogs")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    AllLogs,
  },
};
</script>
